import React, { useContext, useState, createContext } from 'react';
import Toast from './Toast';

interface ToastContextType {
    setIsToastOpen: (isOpen: boolean) => void;
    setToastTitle: (title: string) => void;
    setToastMessage: (message: string) => void;
}

const ToastContext = createContext<ToastContextType | null>(null);

export const ToastProvider = ({ children, ...props } : any) => {
    const [isToastOpen, setIsToastOpen] = useState(false);
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");

    return (
        <ToastContext.Provider value={{ setIsToastOpen, setToastTitle, setToastMessage }}>
            {children}
            <Toast isToastOpen={isToastOpen} onOpenChange={setIsToastOpen} title={toastTitle} message={toastMessage} />
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
      throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};